
(function () {
  'use strict';
  var wrap = document.querySelector('[data-predictive-wrap]');
  if (!wrap) return;
  var input = wrap.querySelector('input[type="search"], input[name="q"]');
  var panel = wrap.querySelector('[data-predictive]');
  var clear = wrap.querySelector('.search-clear');
  if (!input || !panel) return;
  var timer, controller;

  function hide() { panel.hidden = true; panel.innerHTML = ''; }

  function run(q) {
    if (controller) controller.abort();
    controller = new AbortController();
    var url = window.Lamboos.routes.predictive_search_url +
      '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,query,collection,article&resources[limit]=4' +
      '&section_id=predictive-search';
    fetch(url, { signal: controller.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var results = doc.querySelector('[data-predictive-results]');
        panel.innerHTML = results ? results.innerHTML : '';
        panel.hidden = !results;
      })
      .catch(function () {});
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    wrap.classList.toggle('has-value', q.length > 0);
    clearTimeout(timer);
    if (q.length < 2) { hide(); return; }
    timer = setTimeout(function () { run(q); }, 200);
  });

  if (clear) clear.addEventListener('click', function () {
    input.value = ''; wrap.classList.remove('has-value'); hide(); input.focus();
  });

  document.addEventListener('click', function (e) {
    if (!wrap.contains(e.target)) hide();
  });
  input.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
})();
